import React from 'react';
import Modal from '../../../Modal/Modal';

import './PhoneInfo.scss';

declare global {
    interface Window {
        __GGPhoneAnalysisInfoText: string;
    }
}

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20" fill="#fff" className="icon icon--phone">
        <path
            fill="#fff"
            d="M1.3,18a.65.65,0,0,0,.55.7h8.3a.65.65,0,0,0,.55-.7V15.38H1.3ZM6,16a1,1,0,1,1-1,1A1,1,0,0,1,6,16Z"
        />
        <path fill="#fff" d="M10.7,2a.65.65,0,0,0-.55-.7H1.85A.65.65,0,0,0,1.3,2V14.08h9.4Z" />
        <path
            fill="#000"
            d="M10.15,0H1.85A1.93,1.93,0,0,0,0,2V18a1.93,1.93,0,0,0,1.85,2h8.3A1.93,1.93,0,0,0,12,18V2A1.93,1.93,0,0,0,10.15,0ZM1.3,2a.65.65,0,0,1,.55-.7h8.3a.65.65,0,0,1,.55.7V14.08H1.3Zm9.4,16a.65.65,0,0,1-.55.7H1.85A.65.65,0,0,1,1.3,18V15.38h9.4Z"
        />
        <circle cx="6" cy="17" r="1" stroke="#000" />
    </svg>
);

export function PhoneInfo() {
    const [modalVisible, setModalVisibility] = React.useState<boolean>(false);

    return (
        <span
            className="phone-info"
            aria-label="Telefonische Fachberater-Hautbild-Analyse"
            data-balloon-pos="down"
            onClick={() => setModalVisibility(!modalVisible)}
        >
            {icon}
            <Modal
                visible={modalVisible}
                toggleVisibility={() => {
                    setModalVisibility(false);
                }}
                nested={true}
                centerHorizontally={false}
            >
                <div className="info-box">
                    <h2>Telefonische Fachberater-Hautbild-Analyse</h2>
                    <p>{window.__GGPhoneAnalysisInfoText}</p>
                </div>
            </Modal>
        </span>
    );
}
